import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { IAutoAdjustmentRule } from '../interfaces/IAutoAdjustmentRule';

class AutoAdjustmentRuleService extends EntityApiService<IAutoAdjustmentRule> {
  search = (params?: any, config?: RequestConfig): any => {
    const size = params?.size || 10;
    return this.handleSearchResponse(
      ApiClientService.post(this.getPath('/search'), { ...params, populate: true }, config),
      size,
    );
  };
}

export default new AutoAdjustmentRuleService('/ms-compute/api/auto-adjustment-rules');
